const Loader = ({ height = '70%' }) => {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ height: height }}
    >
      <div className="spinner-border" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  )
}

export default Loader
